/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
import React from "react";
import { Checkbox } from "antd";
import { energyManagementPermissions } from "./data";
import PermissionTitle from "./PermissionTitle";
import ModuleHeader from "./ModuleHeader";
import { PERMISSIONS } from "../../Login/constants";
import {
  energyManagementModifyEnergy,
  energyManagementModifyStorage,
  energyManagementModifySupply,
} from "./permissionFunctions";
import EnergyResourcesIcon from "../../../Common/Svgs/EnergyResourcesIcon";

const CONDITIONS = {
  VIEW_AND_EDIT: [
    PERMISSIONS.ENERGY_MANAGEMENT_VIEW,
    PERMISSIONS.ENERGY_MANAGEMENT_NO_ACCESS,
  ],
  REMOVE_ALL: [
    PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_SUPPLY,
    PERMISSIONS.ENERGY_MANAGEMENT_NO_MODIFY_SUPPLY,
    PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_STORAGE,
    PERMISSIONS.ENERGY_MANAGEMENT_NO_MODIFY_STORAGE,
    PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_ENERGY,
    PERMISSIONS.ENERGY_MANAGEMENT_NO_MODIFY_ENERGY,
    PERMISSIONS.ENERGY_MANAGEMENT_VIEW,
    PERMISSIONS.ENERGY_MANAGEMENT_VIEW_AND_EDIT,
    PERMISSIONS.ENERGY_MANAGEMENT_NO_ACCESS,
  ],
};

const EnergyManagementPermissions = ({ permissions, setPermissions }) => {
  // check if the permissions needs to be disabled
  const disabled = CONDITIONS.VIEW_AND_EDIT.some((d) =>
    permissions.includes(d),
  );

  const handleModulePermission = (permissionId) => {
    let local = [];

    if (permissionId === PERMISSIONS.ENERGY_MANAGEMENT_VIEW_AND_EDIT) {
      local = permissions.filter(
        (item) => !CONDITIONS.VIEW_AND_EDIT.includes(item),
      );
    }

    // removing all the energy management permissions
    if (permissionId === PERMISSIONS.ENERGY_MANAGEMENT_VIEW) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    if (permissionId === PERMISSIONS.ENERGY_MANAGEMENT_NO_ACCESS) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    setPermissions([...local, permissionId]);
  };

  const handleIndividualPermission = (permissionId) => {
    let local = [];

    if (permissions.includes(permissionId)) {
      local = permissions.filter((item) => item !== permissionId);
      setPermissions(local);
    } else {
      if (
        permissionId === PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_SUPPLY ||
        permissionId === PERMISSIONS.ENERGY_MANAGEMENT_NO_MODIFY_SUPPLY
      ) {
        // handling either modify supply or don't modify supply
        energyManagementModifySupply({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else if (
        permissionId === PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_STORAGE ||
        permissionId === PERMISSIONS.ENERGY_MANAGEMENT_NO_MODIFY_STORAGE
      ) {
        // handling either view or don't view stop details
        energyManagementModifyStorage({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else if (
        permissionId === PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_ENERGY ||
        permissionId === PERMISSIONS.ENERGY_MANAGEMENT_NO_MODIFY_ENERGY
      ) {
        // handling either view or don't view stop details
        energyManagementModifyEnergy({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else {
        setPermissions((prev) => [...prev, permissionId]);
      }
    }
  };

  return (
    <div>
      <ModuleHeader
        module="Energy Management"
        icon={<EnergyResourcesIcon size={16} className="text-primary" />}
      />
      {/* main module permission */}
      <div className="w-full h-[60px]">
        <div
          className="flex items-center w-full h-full border-b"
          style={{
            background: "#FAF2D8",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="w-[40%] border-r py-3 px-6"
            style={{
              borderColor: "#FAD152",
            }}
          >
            <PermissionTitle
              title={energyManagementPermissions[0].title}
              description={energyManagementPermissions[0].description}
            />
          </div>

          <div className="w-[60%] h-full flex items-center">
            {energyManagementPermissions[0].options.map((option) => {
              // rendering empty div for layout consistency
              if (!option) {
                return (
                  <div
                    className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                    style={{
                      borderColor: "#FAD152",
                    }}
                  />
                );
              }

              const selected = permissions.includes(option.permissionId);

              return (
                <div
                  key={option.text}
                  className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                  style={{
                    borderColor: "#FAD152",
                  }}
                >
                  <Checkbox
                    checked={selected}
                    onClick={() => handleModulePermission(option.permissionId)}
                  />
                  <p
                    className={`font-poppins text-xs ${
                      selected ? "font-medium" : "font-normal"
                    }`}
                  >
                    {option.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* individual functionality permission */}
      <div className="w-full">
        {energyManagementPermissions.slice(1).map((item) => {
          return (
            <div
              key={item.id}
              className="flex items-center w-full h-[60px] border-b"
              style={{
                borderColor: "#DFDFDF",
              }}
            >
              <div
                className="w-[40%] h-full border-r py-3 px-6"
                style={{
                  borderColor: "#DFDFDF",
                }}
              >
                <PermissionTitle
                  title={item.title}
                  description={item.description}
                />
              </div>

              <div className="w-[60%] h-full flex items-center">
                {item.options.map((option, idx) => {
                  // rendering empty div for layout consistency
                  if (!option) {
                    return (
                      <div
                        key={idx}
                        className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                        style={{
                          borderColor: "#DFDFDF",
                        }}
                      />
                    );
                  }

                  const selected = permissions.includes(option.permissionId);

                  // if the permission is view only, remove pointer events and add an opacity
                  return (
                    <div
                      key={option.text}
                      className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                      style={{
                        borderColor: "#DFDFDF",
                        opacity: disabled && 0.5,
                        pointerEvents: disabled && "none",
                      }}
                    >
                      {/* if the permissions should be disabled then it should not
                          show any tick mark else show the selected tick mark */}
                      <Checkbox
                        checked={disabled ? false : selected}
                        onClick={() =>
                          handleIndividualPermission(option.permissionId)
                        }
                      />
                      <p
                        className={`font-poppins text-xs
                            ${selected ? "font-medium" : "font-normal"}
                            `}
                      >
                        {option.text}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EnergyManagementPermissions;
